export enum StructureType {
    DetachedHouse = 1,
    Townhouse = 2,
    Duplex = 3,
    Triplex = 4,
    Quadplex = 5,
    FivePLus = 6,
    CondoInStructure = 7,
    Various = 9,
}
